import { useEffect } from 'react';
import styles from './delete.module.scss';
import { DeleteDealershipsProps } from '../../../../interfaces/components';
import { capitalize } from '../../../../helpers/app';
import ButtonShared from '../../../../components/Button/Button';
import Modal from '../../../../components/Modal/Modal';
import { useToast } from '../../../../helpers/hooks';

const Sidebar = ({
    open,
    setOpen,
    dealershipSelected,
    loading,
    dealerships,
    deleteDealership,
    cleanDeleteDealership
}: DeleteDealershipsProps) => {
    const toast = useToast();

    const onBack = () => {
        setOpen(false)
    }
    
    const onDelete = () => {
        deleteDealership(dealershipSelected?._id)
    }

    useEffect(() => {
        if(dealerships?.delete?.fetching === "failure"){
            toast("Ha ocurrido un error al eliminar la concesionaria");
            cleanDeleteDealership();
        }
        if(dealerships?.delete?.fetching === "success"){
            toast(`Concesionaria ${capitalize(dealershipSelected?.name)} eliminada correctamente`);
            setOpen(false)
            cleanDeleteDealership();
        }
    }, [dealerships?.delete?.fetching]);

    return (
        <Modal open={open} variant="white" className={styles.modal}>
            <p>
                <span className={styles.message}>Estás a punto de eliminar la siguiente concesionaria</span>
                <span className={styles.name}>{capitalize(dealershipSelected?.name)}</span>
            </p>
            <div className={styles.buttons}>
                <ButtonShared 
                    onPress={onBack}
                    title="Regresar" 
                    tertiary
                    size="small"
                    disabled={dealerships?.delete?.fetching === "loading"}
                />
                <ButtonShared 
                    onPress={onDelete}
                    title="Eliminar" 
                    primary
                    size="small"
                    loading={loading}
                />
            </div>
        </Modal>
    )
};
export default Sidebar;